import React from 'react';

interface SearchTasksProps {
    onSearch: (query: string) => void;
}

const SearchTasks: React.FC<SearchTasksProps> = ({ onSearch }) => {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSearch(event.target.value);
    };

    return (
        <div className="custom_input_flled" style={{maxWidth: '400px'}}>
            <input
                id="search-tasks"
                type="text"
                placeholder="Search by title or distribution..."
                onChange={handleInputChange}
                className="form-control"
            />
        </div>
    );
};

export default SearchTasks;
